<template>
    <v-dialog-old @hidden="cancel" :onCloseEsc="closeModal" ref="restoreUserDialog" class="glue" :special-styles="{ width: '650px' }">
        <ValidationObserver ref="validator">
            <fieldset>
                <legend>Восстановление юзера по логину</legend>
                <form>
                    <vee-input v-model="login"
                               rules="required"
                               :input-class="{'hasError': error}"
                               v-tooltip.bottom-end="{
                                  content: login && error ? error : null,
                                  template: tooltipTemplate(),
                               }"/>
                    <button style="margin-top: 11px;" @click.prevent="restore">Восстановить</button>
                </form>
            </fieldset>
        </ValidationObserver>
    </v-dialog-old>
</template>

<script>
    export default {
        data: () => ({
            login: '',
            ok: null,
            processing: false,
            error: null,
        }),
        methods: {
            show() {
                this.$refs.restoreUserDialog.show()
            },
            cancel() {
                this.login = ''
                this.ok = null
                this.error = null
            },
            closeModal() {
                this.cancel()
                this.$refs.restoreUserDialog.hide()
            },
            tooltipTemplate ()  {
                return `<div class="tooltip" role="tooltip"><div class="tooltip-arrow hasError"></div><div class="tooltip-inner hasError"></div></div>`;
            },
            async restore() {
                this.error = null;
                this.$refs.validator.validate().then(async success => {
                    if (!success) {
                        const el = document.querySelector(".hasError:first-of-type");
                        el.scrollIntoView({behavior: "smooth"});
                        return;
                    }

                    this.processing = true;
                    await this.axios.post('/admin/settings/tools/restoreUser/', {login: this.login}).then((response) => {
                        if (response.data.error) {
                            this.error = response.data.error;
                            this.processing = false;
                            return;
                        }

                        this.$modal('Юзер успешно восстановлен',{
                            name: 'ОК',
                            callback: () => {
                                this.closeModal();
                            },
                        },{}, false, 'only-text-dialog')
                        this.processing = false
                    }).catch((error) => {
                        this.processing = false
                    })
                });
            },
        },
    }
</script>
